import { render } from "./SocialNetworksFooter.vue?vue&type=template&id=2b52ce34&ts=true"
import script from "./SocialNetworksFooter.vue?vue&type=script&lang=ts"
export * from "./SocialNetworksFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__